<template>
    <v-chip :color="status.color" size="small" variant="tonal">
        {{ status.label }}
    </v-chip>
</template>

<script>
import moment from 'moment-timezone'
const { managementDateStatus } = require('@/utils/managementDates.cjs')

export default {
    name: 'ManagementDate',
    props: {
        value: { type: String, default: null },
        kind: { type: String, default: 'changed' },
    },
    data() {
        return { now: moment().tz('America/Mexico_City'), timer: null }
    },
    computed: {
        status() { return managementDateStatus(this.value, this.kind, this.now) },
    },
    mounted() {
        this.timer = setInterval(() => { this.now = moment().tz('America/Mexico_City') }, 60000)
    },
    beforeUnmount() { clearInterval(this.timer) },
}
</script>
